import { Button } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import { TbArrowNarrowRight } from 'react-icons/tb';
import type { FC } from 'react';
import { IMAGES } from '../assets';
import type { MtBreederOnboardingPageProps } from '../types';
import * as Styled from '../styled';

export const Step0: FC<Pick<MtBreederOnboardingPageProps, 'onStartClick' | 'loading'>> = (
  props,
) => {
  const { onStartClick, loading = false } = props;

  const { translate } = useTranslation();

  return (
    <Styled.Step0Container>
      <Styled.Step0SubContainer1>
        <Styled.Step0NumberContainer>
          <Styled.Step0Number>1</Styled.Step0Number>
          <Styled.Step0NumberText>
            {translate('common.inputs.steps.aboutYou')}
          </Styled.Step0NumberText>
        </Styled.Step0NumberContainer>
        <Styled.Step0NumberContainer>
          <Styled.Step0Number>2</Styled.Step0Number>
          <Styled.Step0NumberText>
            {translate('common.inputs.steps.breedingPractices')}
          </Styled.Step0NumberText>
        </Styled.Step0NumberContainer>
        <Styled.Step0NumberContainer>
          <Styled.Step0Number>3</Styled.Step0Number>
          <Styled.Step0NumberText>
            {translate('common.inputs.steps.yourDogs')}
          </Styled.Step0NumberText>
        </Styled.Step0NumberContainer>
        <Styled.Step0NumberContainer>
          <Styled.Step0Number>4</Styled.Step0Number>
          <Styled.Step0NumberText>
            {translate('common.inputs.steps.docAndPhoto')}
          </Styled.Step0NumberText>
        </Styled.Step0NumberContainer>
      </Styled.Step0SubContainer1>
      <Styled.Step0SubContainer2>
        <Styled.OnboardingDog isStart src={IMAGES.onboardingDog} />
        <Styled.Step0Header>{translate('common.inputs.steps.diveIn')}</Styled.Step0Header>
        <Styled.Step0Paragraph>
          {translate('common.inputs.steps.createBreed')}
        </Styled.Step0Paragraph>
        <Styled.CreateButtonContainer>
          <Button
            color="blue"
            onClick={onStartClick}
            iconRight={<TbArrowNarrowRight />}
            loading={loading}
          >
            {translate('common.inputs.steps.createBreedButton')}
          </Button>
        </Styled.CreateButtonContainer>
      </Styled.Step0SubContainer2>
    </Styled.Step0Container>
  );
};
